const isComputedRef = (value) => {
  return typeof value === "object" && "_setter" in value;
};
const watchSetter = (ref, cb) => {
  if (!isComputedRef(ref)) {
    return;
  }
  const originalSetter = ref._setter;
  ref._setter = (newValue) => {
    cb(newValue);
    originalSetter(newValue);
  };
};
export {
  watchSetter as w
};
//# sourceMappingURL=watch-setter.js.map
